import { render, staticRenderFns } from "./GetOurCompanyDetails.vue?vue&type=template&id=1567a66c&scoped=true&"
import script from "./GetOurCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./GetOurCompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./GetOurCompanyDetails.vue?vue&type=style&index=0&id=1567a66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567a66c",
  null
  
)

export default component.exports